import {definePreset, palette} from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: palette('#1C2320'),
  },
});

export default MyPreset;
